import React from 'react';
import { ControlledInputField } from '@merchant-portal/components/form-fields';
import LabelWithTooltip from '@merchant-portal/components/label-with-tooltip';
import styled from 'styled-components';
import {
  media,
} from '@payright/web-components';
import type { UseFormMethods } from 'react-hook-form';


const SCPurposeOfLoan = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: top;

  ${media.max.tablet} {
    font-size: 0.86em;
  }

  a {
    color: black;
    font-size: 11px;
  }

  .ref {
    text-decoration: underline;
  }
`;

type PurposeOfLoanProps = {
  error: UseFormMethods['errors']['purposeOfLoan'] | undefined;
  isReadOnly: boolean;
};

export const PurposeOfLoan = ({error, isReadOnly}: PurposeOfLoanProps) => (
  <SCPurposeOfLoan>
    <ControlledInputField
      name="purposeOfLoan"
      placeholder="sporting goods"
      error={error?.message as string}
      readOnly={isReadOnly}
    >
      <LabelWithTooltip
        tooltipContent={
          'Brief description of goods / services being purchased by this customer, e.g. sporting goods, home improvement items, beauty treatment.'
        }
      >
        {' '}
        Description of Goods / Services *{' '}
      </LabelWithTooltip>
    </ControlledInputField>
  </SCPurposeOfLoan>
);
